export default __webpack_public_path__ + "static/media/whatCard1.390e4d66.webp";